// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"36":"d1104f5405d55d49","353":"a256e75aa05b703c","428":"0a3f94ac879af984","567":"019646fb24d0673b"}[chunkId] + ".js";
};